import React, {useContext, useEffect} from 'react'
import {Collapse} from "@material-ui/core";
import FormTranslationContext from "context/FormTranslationContext";
import NoticeGlossaryInput from "../../components/inputs/NoticeGlossaryInput";
import NoticeTextInput from "../../components/inputs/NoticeTextInput";
import NoticeYesNoInput from "../../components/inputs/NoticeYesNoInput";
import NoticeNumericInput from "../../components/inputs/NoticeNumericInput";
import getObjectValue from "libs/getObjectValue";

function OrderDetailsFrameworkAgreement(
    {
        id,
        formikProps
    }) {

    const gId = (name) => id + "." + name;
    const gVal = (name, prefix = true, defaultVal = null) => getObjectValue(prefix ? gId(name) : name, formikProps.values, defaultVal);
    const {getDict} = useContext(FormTranslationContext)

    useEffect(() => {
        if (getObjectValue(id, formikProps.values, null) == null) {
            formikProps.setFieldValue(id, {})
        }
        // eslint-disable-next-line
    }, [])
    return (<>


        <NoticeGlossaryInput
            id={gId("suppliersNumber")}
            formikProps={formikProps}
            items={getDict("SL.MO.031")}
            required
        />

        <NoticeYesNoInput
            formikProps={formikProps}
            id={gId("suppliersNumberLimited")}
            required
        />

        <Collapse in={gVal("suppliersNumberLimited") === true}>
            <NoticeNumericInput
                formikProps={formikProps}
                id={gId("suppliersNumberLimit")}
                required
            />
        </Collapse>

        <Collapse in={gVal("suppliersNumber") === "FrameworkAgreementSeveralContractors"}>
            <NoticeGlossaryInput
                id={gId("art314Order")}
                formikProps={formikProps}
                items={getDict("SL.MO.032")}
            />
        </Collapse>

        <NoticeTextInput
            formikProps={formikProps}
            id={gId("periodExceedInfo")}
            multiline
        />

    </>)
}

OrderDetailsFrameworkAgreement.propTypes = {};

export default OrderDetailsFrameworkAgreement;
